<div class="badge"
  [ngClass]="isInput ? 'badge-secondary' : 'badge-primary'">
  <span class="semi-bold ng-binding"
  [innerHTML]="startDate | date: format"></span>
  @if (endDate) {
    <span>&nbsp; - {{endDate | date: format}}</span>
  }
</div>